import { preloadLayer } from './DistrictLoader';
import SalesDistrictsManager from './SalesDistrictsManager';

/**
 * Render features för en given selection type
 * @param {Object} params - Render parameters
 * @param {string} params.type - Selection type
 * @param {Object} params.mapState - MapStateManager instance
 * @param {Function} params.fetchGeoJSON - Function to fetch GeoJSON
 * @param {Function} params.updateLoadingStates - Callback to update loading states
 * @param {boolean} params.isSalesDistricts - Whether sales districts are visible
 */
export async function renderSelectionTypeFeatures({
    type,
    mapState,
    fetchGeoJSON,
    updateLoadingStates,
    isSalesDistricts
}) {
    // Hantera clear selection
    if (type === 'clear') {
        updateLoadingStates(false, true);
        mapState.setSelectionType('clear');
        
        // Ta bort alla labels när urvalslagret döljs
        if (mapState.labelManager.overlayLabels) {
            mapState.labelManager.removeAllLabels();
        }
        
        updateLoadingStates(false, false);
        return;
    }

    // Sätt selection type
    mapState.setSelectionType(type);

    // Förladda layer om den inte redan är laddad
    await preloadLayer(
        type,
        mapState,
        fetchGeoJSON,
        updateLoadingStates
    );

    // Uppdatera labels för den nya selection type
    if (mapState.labelManager.overlayLabels) {
        mapState.labelManager.removeAllLabels();
    }
    
    mapState.labelManager.handleLabels({
        map: mapState.getMap(),
        maps: mapState.getMaps(),
        turfPolygons: mapState.getAllTurfPolygons(),
        selectionType: mapState.getSelectionType(),
        isSalesDistricts,
        salesDistricts: SalesDistrictsManager.getSalesDistricts()
    });
}

